type Statuses = 'NOT_EXISTS' | 'READY' | 'CREATING' | 'DELETED' | 'PENDING'

export const TrainingStatus: Record<Statuses, string> = {
  NOT_EXISTS: 'NOT_EXISTS',
  CREATING: 'CREATING',
  PENDING: 'PENDING',
  READY: 'READY',
  DELETED: 'DELETED',
}
